import {
  AuthService,
  ConfigStateService,
  CurrentTenantDto,
  CurrentUserDto,
  SessionStateService,
} from '@abp/ng.core';
import { ToasterService } from '@abp/ng.theme.shared';
import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FilterStateService } from '../../services/filter-state.service';
import { Store } from '@ngxs/store';
import { LanguageDto } from '@volo/abp.ng.language-management/proxy';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import snq from 'snq';

@Component({
  selector: 'app-nav-items',
  templateUrl: './nav-items.component.html',
  styleUrls: ['./nav-items.component.scss'],
})
export class NavItemsComponent implements OnInit {
  @ViewChild('currentUser', { static: false, read: TemplateRef }) currentUserRef: TemplateRef<any>;
  @ViewChild('language', { static: false, read: TemplateRef }) languageRef: TemplateRef<any>;
  @Input() smallScreen: boolean;
  @Input() isCollapseNavbarTool: boolean;
  currentUser$: Observable<CurrentUserDto>;
  selectedTenant$: Observable<CurrentTenantDto>;
  languages$: Observable<LanguageDto[]>;

  constructor(
    private store: Store,
    private authService: AuthService,
    private modalService: NgbModal,
    private sessionStateService: SessionStateService,
    private configState: ConfigStateService,
    private router: Router,
    private filterState: FilterStateService,
    private toaster: ToasterService
  ) {}

  get defaultLanguage$(): Observable<{ displayName: string; flagIcon: string }> {
    return this.languages$.pipe(
      map(languages => {
        const lang: Partial<LanguageDto> = snq(
          () =>
            languages.find(
              language => language.cultureName === this.sessionStateService.getLanguage()
            ),
          {} as Partial<LanguageDto>
        );
        return {
          displayName: lang.displayName || '',
          flagIcon: lang.flagIcon,
        };
      })
    );
  }

  get dropdownLanguages$(): Observable<LanguageDto[]> {
    return this.languages$.pipe(
      map(
        languages =>
          snq(() =>
            languages.filter(lang => {
              if (lang.cultureName === 'tr' || lang.cultureName === 'en') {
                return lang.cultureName !== this.sessionStateService.getLanguage();
              }
            })
          ),
        []
      )
    );
  }

  get fullscreen(): boolean {
    return window.innerHeight === screen.height;
  }

  ngOnInit() {
    this.languages$ = this.configState.getDeep$('localization.languages');
    this.currentUser$ = this.configState.getDeep$('currentUser');
    this.selectedTenant$ = this.sessionStateService.getTenant$();
  }

  changeLang(cultureName: string) {
    if (cultureName === 'ar') {
      setTimeout(() => location.reload(), 500);
    }
    this.store.dispatch(this.sessionStateService.setLanguage(cultureName));
  }

  logout() {
    this.filterState.clearAll();
    this.authService.logout().subscribe();
  }

  clearFilterCache() {
    this.filterState.clearAll();
    this.toaster.success('::FilterCacheCleared', '', { life: 3000 });
    // Reload so the page currently open also drops its in-memory filters, but leave the toast
    // enough time to be seen - a synchronous reload tears the page down before it paints.
    setTimeout(() => window.location.reload(), 900);
  }

  openVersionModal(content) {
    this.modalService.open(content, {
      ariaLabelledBy: 'modal-basic-title',
      centered: true,
      size: 'md',
    });
  }

  onClickManageProfile() {
    this.router.navigate(['account/manage']);
  }
}
